import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const StyledFooterSocial = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: flex-end;

  @media (max-width: ${props => props.theme.mediaMd}) {
    justify-content: center;
  }
`;
export default function FooterSocial({
  children = null
}) {
  return children && /*#__PURE__*/React.createElement(StyledFooterSocial, {
    "aria-label": "Social networks"
  }, children);
}
FooterSocial.propTypes = {
  children: PropTypes.node
};
//# sourceMappingURL=social.js.map